import React, { useState } from "react";
import { Query, withApollo } from "react-apollo";
import { getSessionInformation } from "cci-data";
import PropTypes from "prop-types";
import { withRouter } from "cci-utility";

/*
 * Saves ids of SessionInformation in Storage.
 */
const saveUserOnStorage = (storage, sessionInfo) => {
  storage.save({
    key: "user",
    data: {
      businessId: sessionInfo.currentBusiness && sessionInfo.currentBusiness.id,
      officeId: sessionInfo.currentOffice && sessionInfo.currentOffice.id,
      userId: sessionInfo.user && sessionInfo.user.id
    }
  });
};

/**
 * Shows a progress screen until the server responds with the session information.
 *
 * Aside from being a user friendly piece of the app,
 * this component also ensures that a GraphQL query is performed before any
 * authenticated condition (in AppProvider).
 */
const AppLoader = ({
  client,
  authenticated,
  loaderComponent,
  children,
  storage,
  connectionLost,
  redirectOnSwitch,
  ...restProps
}) => {
  const [sessionInfo, setSessionInfo] = useState(null);

  client
    .query({
      query: getSessionInformation,
      errorPolicy: "ignore",
      fetchPolicy: "network-only",
      variables: { authenticated }
    })
    .then(result => {
      if (result && result.data && result.data.sessionInformation) {
        /*
         * If the userData found in Storage has not same BusinessId, OfficeId
         * and UserId as the userData of SessionInformation,
         * the user is redirected to root: "/"
         *
         * This is done because of the new user may not have corresponding
         * permissions to view the current page.
         */
        storage
          .load({
            key: "user",
            autoSync: false,
            syncInBackground: false
          })
          .then(userStorage => {
            if (
              userStorage.businessId !==
                result.data.sessionInformation.currentBusiness.id ||
              userStorage.officeId !==
                result.data.sessionInformation.currentOffice.id ||
              userStorage.userId !== result.data.sessionInformation.user.id
            ) {
              // Redirection
              redirectOnSwitch && restProps.history.replace("/");

              // New User Data on Storage
              saveUserOnStorage(storage, result.data.sessionInformation);
            }
          })
          .catch(error => {
            // If user is NOT found on storage history to root: /
            restProps.history.replace("/");

            // New User Data on Storage
            saveUserOnStorage(storage, result.data.sessionInformation);
          });

        setSessionInfo(result.data.sessionInformation);
      }
    })
    .catch(err => {});

  /*
   * This causes that the Loading panel to be shown sometimes when the page
   * is loaded and user is not authenticated,
   * and when an awesome alert must be shown.
   */
  if (authenticated === true && !connectionLost && !sessionInfo) {
    return loaderComponent;
  }

  return children;
};

AppLoader.propTypes = {
  authenticated: PropTypes.bool.isRequired,
  loaderComponent: PropTypes.element.isRequired,
  children: PropTypes.node.isRequired,
  connectionLost: PropTypes.bool.isRequired
};

export default withApollo(withRouter(AppLoader));
